__webpack_require__.p = "/mindease/";